import React from 'react';
import { Trans } from 'react-i18next';
import PoweredByAirthingsLogo from 'commons/src/img/logos/Powered_by_airthings';
import { homepageLink, publicDashboardUrl } from '../../constants';

export const Footer = (): React.ReactElement => {
    const pathname = window.location.pathname;
    const publicDashboard = pathname.includes(publicDashboardUrl);
    return (
        <footer className="footer" id="footer">
            <PoweredByAirthingsLogo />
            {!publicDashboard && (
                <div className="footer__text">
                    <Trans i18nKey="PublicIAQDashboard.Footer">
                        <a href={homepageLink} target="_blank" rel="noopener noreferrer">
                            {homepageLink}
                        </a>
                    </Trans>
                </div>
            )}
        </footer>
    );
};

export default Footer;
